import CoStreaming from './CoStreaming'

export default CoStreaming
